import PDF_LAYOUTS from "./pageLayouts.json";
import { getFramePageInsets } from "./spine.config.js";
export { PDF_LAYOUTS };

export function pdfPageCells(layout, side = "left") {
  const spec = PDF_LAYOUTS[typeof layout === "string" ? layout : layout?.id];
  if (!spec) return null;
  const outer = Math.min(...spec.cells.map(c => c[0]));
  const edge = Math.max(...spec.cells.map(c => c[0] + c[2]));
  // Координаты исходного PDF-макета на полном листе.
  // Переносим блок целиком, не меняя порядок фотографий.
  const shift = side === "right" ? spec.width - edge - outer : 0;
  return spec.cells.map(([x, y, w, h]) => ({
    x: (x + shift) / spec.width, y: y / spec.height,
    w: w / spec.width, h: h / spec.height, aspect: w / h,
  }));
}

export function pageCells(layout, side, width = 155, height = 210, count = 0) {
  const fixed = pdfPageCells(layout, side);
  if (fixed) return fixed;
  const inset = layout?.framed ? getFramePageInsets(side, count, width, height)
    : { left: 0, right: 0, top: 0, bottom: 0 };
  const aw = 1 - inset.left - inset.right, ah = 1 - inset.top - inset.bottom;
  const rows = layout?.rows || [];
  const sumH = rows.reduce((s, row) => s + (parseFloat(row.height) || 0), 0) || 1;
  const result = [];
  let y = inset.top;
  for (const row of rows) {
    const h = (parseFloat(row.height) || 0) / sumH * ah;
    const total = row.slots.reduce((s, slot) => s + (slot.flex ?? 1), 0) || 1;
    let x = inset.left;
    for (const slot of row.slots) {
      const w = (slot.flex ?? 1) / total * aw;
      const nested = slot.columnSlots || [{ flex: 1 }];
      const sum = nested.reduce((s, cell) => s + (cell.flex ?? 1), 0) || 1;
      let cy = y;
      for (const cell of nested) {
        const ch = (cell.flex ?? 1) / sum * h;
        result.push({ x, y: cy, w, h: ch });
        cy += ch;
      }
      x += w;
    }
    y += h;
  }
  return result;
}
export const cellStyle = cell => ({ position: "absolute",
  left: `${cell.x * 100}%`, top: `${cell.y * 100}%`,
  width: `${cell.w * 100}%`, height: `${cell.h * 100}%`,
});